module.exports = __webpack_public_path__ + "static/yuan_ti_nightmare_speaker-15e8ce5c35cbce0a6a4207408ca788e0.jpeg";